import { Button } from 'antd'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import {
  HeaderWrapper,
  PageTitle,
  SearchInput,
  TabsRow,
  Tab,
  ControlsContainer,
} from './styles/DashboardHeaderStyles'

export type ProjectTab = 'active' | 'archived'

interface DashboardHeaderProps {
  searchText: string
  onSearchChange: (value: string) => void
  onCreateProject: () => void
  hasProjects: boolean
  activeTab: ProjectTab
  onTabChange: (tab: ProjectTab) => void
  archivedCount: number
}

export function DashboardHeader({
  searchText,
  onSearchChange,
  onCreateProject,
  hasProjects,
  activeTab,
  onTabChange,
  archivedCount,
}: DashboardHeaderProps) {
  return (
    <HeaderWrapper>
      <PageTitle level={2}>My projects</PageTitle>

      {hasProjects && (
        <TabsRow>
          <Tab $active={activeTab === 'active'} onClick={() => onTabChange('active')}>
            Active
          </Tab>
          <Tab $active={activeTab === 'archived'} onClick={() => onTabChange('archived')}>
            Archived{archivedCount > 0 && ` (${archivedCount})`}
          </Tab>
          <ControlsContainer>
            <SearchInput
              placeholder="Search projects..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => onSearchChange(e.target.value)}
              allowClear
            />
            <Button type="primary" icon={<PlusOutlined />} onClick={onCreateProject}>
              New project
            </Button>
          </ControlsContainer>
        </TabsRow>
      )}
    </HeaderWrapper>
  )
}
